// extracted by mini-css-extract-plugin
export default {"column":"column--o5rDwXpXIlEjbhKihTNI"};